webpackJsonp([247658369337294],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cta = __webpack_require__(41);
	
	var _cta2 = _interopRequireDefault(_cta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* We're putting each word into its own span because the gradient style
	will otherwise apply across the entire block. (This becomes problematic
	if it wraps beyond one line.) */
	function renderGradientH4(string) {
	  return _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: '<span>' + string.replace(/ /g, '</span> <span>') + '</span>' } });
	}
	
	var MissionPage = function MissionPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Mission'
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'mission' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'When I was in middle school, I asked myself a question:'
	      ),
	      renderGradientH4('How should I live my life to create the greatest possible positive impact on the world?'),
	      _react2.default.createElement(
	        'p',
	        null,
	        'My impact, I reasoned, would equal the number of people I touch with my work multiplied by how much their lives improve as a result.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Around the same time, I started teaching myself to code. I was enamored by the idea that software I wrote once could reach millions of people around the world \u2014 even in developing regions where internet access was becoming increasingly common.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'It seemed clear that scalable software would help maximize the number of people I could reach, but what should that software help people to do? Consider this:'
	      ),
	      renderGradientH4('For most of history, access to education has been a rare privilege, limited by wealth, class, and geography.'),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Humanity\'s raw potential, on the other hand, is not nearly as limited.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'There have been billions of people throughout history who possessed the potential to do great things but never had access to the education necessary to realize that potential.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Further, education has a ripple effect: not only does it improve the learner\'s life, but it also better equips them to improve their community and the world around them.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Thinking about this led me to my guiding question\u2026'
	      ),
	      renderGradientH4('What might the world look like if everyone with the potential to change it had the education necessary to actually do so?'),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Imagine a world where every individual has the opportunity to reach his or her fullest potential. For every Einstein or Shakespeare, what if we had a hundred times as many people with similar levels of ability? What might the world look like if everyone was operating at their peak performance, doing the very best work they could possibly do?'
	      ),
	      renderGradientH4("Education technology is how that happens. And it's my life's mission to see that it does.")
	    ),
	    _react2.default.createElement(_cta2.default, { primary: { to: '/work', text: 'View Work' }, scrollToTop: true })
	  );
	};
	
	exports.default = MissionPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-mission-js-c1bedf1e7c9a24357e42.js